import React from "react";
import classNames from "classnames";
import {Field} from "redux-form";
import Grid from "@material-ui/core/Grid";
import RadioField from "../RadioField";

import hobbies from "../../mocks/hobbies";

import styles from "./question.module.scss";

function FourthQuestion() {
  return (
    <Grid container>
      <Grid item md={6} xs={12}>
        <div className={classNames(styles.icon, styles.hobbyIcon)}></div>
      </Grid>
      <Grid item md={6} xs={12}>
        <h3 className={styles.title}>Чем увлекается</h3>
        <Grid container className={styles.content}>
          {hobbies.map(({value, label}, i) => (
            <Grid key={value} item xs={i % 2 ? 5 : 7}>
              <Field
                name="hobby"
                component={RadioField}
                type="radio"
                value={value}
                label={label}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}

FourthQuestion.propTypes = {};

export default FourthQuestion;
